import { sortInOrgRoleOrder } from '@/features/rbac/lib/sortByRole';
import { supabase } from '@/lib/supabase/supabaseClient';

export const getOrganizations = async () => {
  const organizations = await supabase
    .from('organisation')
    .select(
      `
    *,
    organisation_members( user_id, user(id, first_name, last_name, email) ),
    owner:user!owner_id(id, first_name, last_name)`
    )
    .throwOnError()
    .then((res) => res.data);
  if (!organizations) throw new Error(`Couldn't fetch organizations`);
  return Promise.all(
    organizations.map(async (org) => {
      const memberRows = org.organisation_members || [];
      const userIds = memberRows.map((m) => m.user_id);

      const rolesData = await supabase
        .from('user_organization_role')
        .select(
          'user_id, organization_role_id, organization_id, role:role_based_organization_access_control(*)'
        )
        .in('user_id', userIds)
        .eq('organization_id', org.id)
        .throwOnError()
        .then((res) => res.data);
      if (!rolesData) throw new Error('Error fetching organization roles');
      const membersWithRoles = memberRows
        .map((m) => ({
          ...m,
          user: m.user,
          role: rolesData.find((r) => r.user_id === m.user_id)?.role,
        }))
        .sort((a, b) => sortInOrgRoleOrder(a.role?.role, b.role?.role))
      return {
        ...org,
        organisation_members: membersWithRoles,
      };
    })
  );
};
